import { NOTIFY_ERROR, NOTIFY_SUCCESS } from 'src/vuex/modules/snackbar/types'
import * as apiCalls from '../apiCalls'
import texts from '../texts'
import * as types from './types'

export default {
  [types.GET_ETPS]: async ({ commit, getters, dispatch }) => {
    commit(types.SET_IS_LOADING, true)

    try {
      const params = getters[types.PARAMS_TO_SEND]

      const response = await apiCalls.getEtps(params)

      commit(types.SET_ETPS, response.etps)
      commit(types.SET_TOTAL_ITEMS, response.pagination.total_items)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })

      commit(types.SET_ETPS, [])
      commit(types.SET_TOTAL_ITEMS, 0)
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.GET_ETP_DETAILS]: async ({ commit, dispatch }, etpId) => {
    commit(types.SET_IS_LOADING, true)

    try {
      const details = await apiCalls.getEtpDetails(etpId)
      commit(types.SET_SELECTED_ETP, details)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.CHANGE_PAGINATION]({ commit }, newPagination) {
    commit(types.SET_PAGINATION, newPagination)
  },
  [types.CHANGE_FILTERS]({ commit, dispatch }, { key, value }) {
    commit(types.SET_FILTERS, {
      key,
      value
    })
    dispatch(types.GET_ETPS)
  },
  [types.RESET_PAGINATION]({ state, dispatch }) {
    dispatch(types.CHANGE_PAGINATION, {
      ...state.pagination,
      page: 1
    })
  },
  [types.GET_INVESTORS]: async ({ commit, dispatch }) => {
    try {
      const investors = await apiCalls.findInvestors()
      commit(types.SET_INVESTORS, investors.investors)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    }
  },
  [types.GET_SELECTED_INVESTOR]: ({ commit, dispatch }, investor) => {
    commit(types.SET_SELECTED_INVESTOR, investor)
    dispatch(types.GET_ACCOUNTS)
  },
  [types.GET_ACCOUNTS]: async ({ state, commit, dispatch }) => {
    try {
      const params = {
        owner_id: state.manualBid.selectedInvestor,
        currency: state.selectedEtp.currency
      }
      const accounts = await apiCalls.getAccounts(params)
      commit(types.SET_ACCOUNTS, accounts.results)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    }
  },
  [types.GET_SELECTED_ACCOUNT]: async ({ commit, dispatch }, account) => {
    commit(types.SET_SELECTED_ACCOUNT, account)
    dispatch(types.GET_BID_DATA)
  },
  [types.GET_BID_DATA]: async ({ state, getters, commit, dispatch }) => {
    try {
      const accountId = state.manualBid.selectedAccount
      const balances = await apiCalls.getBalances(accountId)

      const pending_amount = getters[types.PENDING_AMOUNT]

      commit(types.SET_ACCOUNT_BALANCE, balances.net)
      commit(types.SET_ETP_PENDING_AMOUNT, pending_amount)
      commit(types.SET_BID_SIZE, pending_amount)
    } catch (err) {
      console.error(err)
      commit(types.SET_CLEAR_BID_DATA)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    }
  },
  [types.TOGGLE_BIDDING_DIALOG]({ state, commit }) {
    commit(types.SET_BIDDING_DIALOG, !state.dialogsVisibility.biddingDialog)
  },
  [types.PLACE_BID]: async ({ state, commit, dispatch }, payload) => {
    commit(types.SET_IS_DIALOG_LOADING, true)
    try {
      await apiCalls.manualBid(state.selectedEtp.id, payload)
      commit(types.SET_IS_DIALOG_LOADING, false)
      dispatch(NOTIFY_SUCCESS, { message: texts.success })
      dispatch(types.TOGGLE_BIDDING_DIALOG)
      setTimeout(() => {
        window.location.reload()
      }, 2500)
    } catch (err) {
      commit(types.SET_IS_DIALOG_LOADING, false)
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    }
  },
  [types.CANCEL_ETP]: async ({ state, commit, dispatch }) => {
    commit(types.SET_IS_LOADING, true)

    try {
      await apiCalls.cancelEtp(state.selectedEtp.id)

      dispatch(NOTIFY_SUCCESS, {
        message: 'ETP updated successfully'
      })
      dispatch(types.GET_ETP_DETAILS, state.selectedEtp.id)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.DEFAULT_ETP]: async ({ state, commit, dispatch }) => {
    commit(types.SET_IS_LOADING, true)

    try {
      await apiCalls.defaultEtp(state.selectedEtp.id)

      dispatch(NOTIFY_SUCCESS, {
        message: 'ETP updated successfully'
      })
      dispatch(types.GET_ETP_DETAILS, state.selectedEtp.id)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  },
  [types.WRITE_OFF_ETP]: async ({ state, commit, dispatch }) => {
    commit(types.SET_IS_LOADING, true)

    try {
      await apiCalls.writeOffEtp(state.selectedEtp.id)

      dispatch(NOTIFY_SUCCESS, {
        message: 'ETP updated successfully'
      })
      dispatch(types.GET_ETP_DETAILS, state.selectedEtp.id)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data.message })
    } finally {
      commit(types.SET_IS_LOADING, false)
    }
  }
}
